'use strict';

/**
 *  @param {Object} addressResult - addressResult object from google
 *  @returns {boolean} valid
 */
function validatePincodeFromGeocodeResult(addressResult) {
    var valid = false;
    var stateFilled = false;
    var cityFilled = false;
    var components = addressResult && addressResult.results && addressResult.results[0].address_components;
    for (let index = 0; index < components.length; index += 1) {
        const component = components[index];
        if (component.types.includes('locality') || component.types.includes('administrative_area_level_3')) {
            $('#city').val(component.long_name);
            $('#city').addClass('has-value');
            cityFilled = true;
        }
        if (component.types.includes('administrative_area_level_1')) {
            $('#state').val(component.long_name);
            $('#state').addClass('has-value');
            stateFilled = true;
        }
    }
    if (stateFilled && cityFilled) {
        valid = true;
    }
    return valid;
}

module.exports = {
    validatePincodeFromGeocodeResult
};
